module.exports = __webpack_public_path__ + "static/media/customStep4.12a696b3.png";